/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { getLocaleByCode } from 'cio/utils/languages';

interface LocaleTagArgs {
  lcid: string;
  labelClassNames?: string;
}

export default class LocaleTag extends Component<LocaleTagArgs> {
  get lcidHasValidCountryCode() {
    return this.args.lcid.match(/-[A-z]{2}$/);
  }

  get countryCode() {
    if (!this.lcidHasValidCountryCode) {
      return;
    }

    let splitLcid = this.args.lcid.split('-');

    return splitLcid[splitLcid.length - 1].toLowerCase();
  }

  get label() {
    let { lcid } = this.args;
    if (isEmpty(lcid)) {
      return 'Default';
    }

    return getLocaleByCode(lcid)?.code ?? lcid;
  }
}
